import type { InputHTMLAttributes, ReactNode } from 'react'
import styles from './Input.module.css'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
  leadIcon?: ReactNode
  trailIcon?: ReactNode
}

export function Input({ error, leadIcon, trailIcon, className, ...props }: InputProps) {
  const inputClasses = [
    styles.input,
    error && styles.error,
    leadIcon && styles.hasLeadIcon,
    trailIcon && styles.hasTrailIcon,
  ].filter(Boolean).join(' ')

  const wrapperClasses = [styles.wrapper, className].filter(Boolean).join(' ')

  return (
    <div className={wrapperClasses}>
      {leadIcon ? <span className={styles.leadIcon}>{leadIcon}</span> : null}
      <input className={inputClasses} data-lpignore="true" {...props} />
      {trailIcon && <span className={styles.trailIcon}>{trailIcon}</span>}
    </div>
  )
}
